module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/rgU03i/images/cover.jpg?1684229398104",
      "alt": "This image is the cover for the book Maritime Tales of Lake Ontario"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Maritime Tales of Lake Ontario\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("Battles, shipwrecks and abundant adventures await in this volume of maritime tales by local author Susan Gately.")])]), _c('br'), _c('p', [_vm._v("Easternmost of the Great Lakes, Lake Ontario is bordered by both New York and Ontario. Upon its pristine surface, countless vessels have sailed, but its bottom depths are littered with the skeletons of shipwrecks, including HMS Ontario, caught and destroyed in one of the sudden storms that often turn this sea-like lake deadly. Daring mariners, male and female, have seen their share of peril, and battles during wars between Britain and the United States and Canada have also been waged here. From Huron canoes to today's \"Sunday sailors\" who venture from shore only during warmer months, local author Susan Gateley tells some of the lake's most exciting stories.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Susan Peterson Gateley\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Susan Gateley is a locally and nationally published writer. She has authored six full length nonfiction books on Lake Ontario, as well as several shorter works. She is active in the North Wolcott and Sterling Historical Societies, and she publishes the Lake Ontario Log at SilverWaters.com.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0